const LOGIN_ENCRYPTION_ALGORITHM = "RSA-OAEP-256+A256GCM";

function cryptoApi() {
  if (
    typeof window === "undefined" ||
    !window.isSecureContext ||
    !window.crypto ||
    !window.crypto.subtle
  ) {
    throw new Error("当前页面不是安全上下文，无法安全登录，请使用 HTTPS 或 localhost");
  }
  return window.crypto;
}

function decodeBase64(value) {
  const binary = window.atob(value);
  const bytes = new Uint8Array(binary.length);
  for (let index = 0; index < binary.length; index += 1) {
    bytes[index] = binary.charCodeAt(index);
  }
  return bytes;
}

function encodeBase64(value) {
  const bytes = value instanceof Uint8Array ? value : new Uint8Array(value);
  let binary = "";
  for (let index = 0; index < bytes.length; index += 1) {
    binary += String.fromCharCode(bytes[index]);
  }
  return window.btoa(binary);
}

export async function encryptLoginPayload(key, payload) {
  if (
    !key ||
    !key.keyId ||
    !key.publicKey ||
    key.algorithm !== LOGIN_ENCRYPTION_ALGORITHM
  ) {
    throw new Error("服务器返回了无效的登录加密凭证");
  }

  const crypto = cryptoApi();
  const encoder = new TextEncoder();
  const publicKey = await crypto.subtle.importKey(
    "spki",
    decodeBase64(key.publicKey),
    { name: "RSA-OAEP", hash: "SHA-256" },
    false,
    ["encrypt"]
  );
  const contentKey = await crypto.subtle.generateKey(
    { name: "AES-GCM", length: 256 },
    true,
    ["encrypt"]
  );
  const rawContentKey = await crypto.subtle.exportKey("raw", contentKey);
  const iv = crypto.getRandomValues(new Uint8Array(12));
  const additionalData = encoder.encode(key.keyId);
  const plaintext = encoder.encode(
    JSON.stringify({
      ...payload,
      issuedAt: Date.now(),
    })
  );

  const [encryptedKey, encryptedPayload] = await Promise.all([
    crypto.subtle.encrypt({ name: "RSA-OAEP" }, publicKey, rawContentKey),
    crypto.subtle.encrypt(
      { name: "AES-GCM", iv, additionalData, tagLength: 128 },
      contentKey,
      plaintext
    ),
  ]);

  return {
    keyId: key.keyId,
    encryptedKey: encodeBase64(encryptedKey),
    iv: encodeBase64(iv),
    encryptedPayload: encodeBase64(encryptedPayload),
  };
}
